module.exports = __webpack_public_path__ + "static/media/matthew_clavane.68546a99.jpg";